import React from 'react';
import { NavLink, NavLinkProps } from 'reactstrap';

export const BaseNavLink: React.FC<NavLinkProps> = (props) => (
  <NavLink {...props}>
    {props.children}
  </NavLink>
);
